export enum StudentsFolder {
  SCHOOLYEAR_AB = 'SY',
  FILE_NAME_DEFAULT = 'sample.pdf',
  FOLDER_NAME_DEFAULT = 'DownloadAllStudentRecordFiles.zip',
  ZIP = '.zip',
}
